<template>
  <v-popover
    offset="10"
    trigger="hover"
    :placement="placement"
    popoverBaseClass="bg-tooltip"
    :popoverInnerClass="`bg-tooltip__inner ${
      dark ? 'bg-tooltip__inner--dark' : null
    }`"
    :delay="{ show: 100, hide: 300 }"
    :disabled="disabled"
  >
    <span class="bg-tooltip__target">
      <slot v-if="!info" name="target"></slot>
      <BgIcon
        v-if="info"
        :class="`bg-tooltip__info-icon bg-tooltip__info-icon--${color}`"
        name="information"
      />
    </span>

    <template slot="popover">
      <span class="bg-tooltip__content">
        <slot name="content"></slot>
      </span>
    </template>
  </v-popover>
</template>

<style scoped>
@import "./styles.css";
</style>

<script>
import BgIcon from "../bg-icon";
import { VPopover } from "v-tooltip";

export default {
  name: "BgTooltip",
  components: {
    VPopover,
    BgIcon,
  },
  props: {
    placement: {
      type: String,
      default: "top",
    },
    info: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
  },
};
</script>
